import React from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { connect } from 'react-redux';
import SearchMake from '@Builder/searchModelRule/make/SearchMake';
import { Link } from 'react-router-dom';

const SearchModelRulePage: React.FC<SearchModelRulePageProps> = ({}) => {
  return <div>
    <Breadcrumb>
      <BreadcrumbItem>
        <Link to={`/${document.documentElement.lang}/builder/army_lists`}>
          <i className="fa-solid fa-house"></i>
        </Link>
      </BreadcrumbItem>
      <BreadcrumbItem active>Search army list</BreadcrumbItem>
    </Breadcrumb>

    <SearchMake/>
  </div>;
}


const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SearchModelRulePage);

type SearchModelRulePageProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>